import { MutableRefObject, useEffect, useMemo, useRef, useState } from "react";
import { useStore } from "../../../../store/store";
import Button from "../../../../components/Button";
import { Body, ContentWrapper, CTA, EnrollmentDateHeadline, Gift, Headline, Heighlight, Image, ImageWrapper, LotteryContainer, LotteryContentContainer, LotteryIcon, LotteryImgContainer, MobilePayContainer, MobilePayImgDescription, MobilePayLi, MobilePayOl, MobilePaySwipeImage, ParagraphContainer, SubHeadline, Wrapper } from "./ThankYouStep.style";
import Analytics from "../../../../utils/analytics";
import { TrackingFlowTypeEnum } from "../../../../types/TrackingFlowTypeEnum";
import { PaymentTypeEnum } from "../../../../types/PaymentTypesEnum";
import { C } from "react-router/dist/development/index-react-server-client-1TI9M9o1";
import { Content } from "../../components/Accordion/Accordion.style";


export default function ThankYouStep() {
  const payload = useStore.usePayload();
  const trackAndTraceUrl = useStore.useTrackAndTraceUrl();
  const WrapperRef = useRef() as MutableRefObject<HTMLDivElement>;
  const [showMobilePay, setShowMobilePay] = useState(false);

  useEffect(() => {
    if(payload.paymentType === PaymentTypeEnum.MOBILE_PAY) {
      setShowMobilePay(true);
    } else {
      setShowMobilePay(false);
    }
  },[payload])

  useEffect(() => {
    scrollTo({ top: WrapperRef.current.offsetTop - 300, behavior: "smooth" })
  }, [WrapperRef])

  const productsBought = useMemo(() => {
    const productList = [];

    if (payload.wantsUnemploymentBenefits) {
      productList.push("A-kasse");
    }
    if (payload.wantsUnion) {
      productList.push("Fagforening");
    }
    if (payload.wantsSalaryInsurance) {
      productList.push("Lønsikring");
    }
    if (payload.wantsBasic) {
      productList.push("Ase selvstændig");
    }
    if (payload.wantsHRJura) {
      productList.push("HR Jura");
    }

    return productList;
  }, []);

  const curentDate = useMemo(() => {
    const today = new Date(payload.signupDate);
    const date = today.getDate();
    const month = today.getMonth()+1;
    const year = today.getFullYear();
    
    return date + "/" + month + "/" + year;
  }, [])

  return (
     
    <Wrapper  ref={WrapperRef}>
      <ContentWrapper>
        <EnrollmentDateHeadline>Dit medlemskab er aktivt fra {curentDate}</EnrollmentDateHeadline>
        <Body>
          {showMobilePay && (
            <> 
            <SubHeadline>Kvittering</SubHeadline>
            <Headline>Velkommen, {payload.firstName}</Headline>
             <p>Tak fordi du har valgt os. Vi er glade for at have dig med ombord!</p>
             {(payload.wantsUnemploymentBenefits && payload.giftcard) && (
              <ParagraphContainer>
                <p>Vi sender dit gavekort til <strong>{payload.mailAddress}</strong> hurtigst muligt, efter vi kan se din betaling.</p>
              </ParagraphContainer>
            )}
            <ParagraphContainer>
              <Heighlight>Du er næsten i mål – bare ét swipe tilbage!</Heighlight>
            <MobilePayOl>
              <MobilePayLi>Åbn MobilePay og find betalingsaftalen fra os</MobilePayLi>
              <MobilePayLi>Swipe for at oprette. <br/><span>Bemærk</span>: linket udløber efter 10 minutter, så det er en god idé at swipe med det samme</MobilePayLi>
              <MobilePayLi>Du kan se aftalen under 'Betalingsaftaler' i din MobilePay-app</MobilePayLi>
              <MobilePayLi>Alle fremtidige betalinger sker automatisk</MobilePayLi>
            </MobilePayOl>
            <MobilePayContainer>
              <MobilePaySwipeImage src="/assets/images/mobilePay.svg" />
              <MobilePayImgDescription>Husk at swipe</MobilePayImgDescription>
            </MobilePayContainer>
            </ParagraphContainer>
            <ParagraphContainer>
              <Heighlight>Vil du følge din indmeldelse?</Heighlight>
              <p>Klik på knappen og se din status.</p>
              {/* <Button href={trackAndTraceUrl}>Følg din indmeldelse</Button> */}
              <CTA className="button" href={trackAndTraceUrl}>Følg din indmeldelse</CTA>
            </ParagraphContainer>
            {/* <MobilePaySwipeImage src="/assets/images/mobilePay-swipe.png" /> */}
          </>
          )}

          {!showMobilePay && (
          <>
          <ParagraphContainer>
            <SubHeadline>Kvittering</SubHeadline>
            <Headline>Velkommen, {payload.firstName}!</Headline>
            <p>Tak fordi du har valgt os. Vi er glade for at have dig med ombord!</p>
          </ParagraphContainer>
            {(payload.wantsUnemploymentBenefits && payload.giftcard) && (
              <ParagraphContainer>
                 <p>Vi sender dit gavekort til <strong>{payload.mailAddress}</strong> hurtigst muligt, efter vi kan se din betaling.</p>
              </ParagraphContainer>
            )}
          {payload.wantsUnemploymentBenefits && (
            <ParagraphContainer>
            <Heighlight>Betal din første regning i MobilePay nu</Heighlight>
            <p>
              Vi har sendt en betalingsanmodning til din MobilePay. Åbn appen, og swipe for at betale. Dit medlemskab bliver aktivt, når betalingen er gennemført. Det er kun den første regning, du betaler med MobilePay.
            </p>
          </ParagraphContainer>
          )}
          {payload.wantsUnemploymentBenefits && (
            <ImageWrapper>
              <Image src="/assets/images/ase-Swipe-i-MP.png" alt="Mobilepay" />
            </ImageWrapper>
          )}
          <ParagraphContainer>
            <Heighlight>Betal fremover via Betalingsservice</Heighlight>
            <p>Dine fremtidige regninger betaler du via Betalingsservice - vi sætter det op for dig. Du skal ikke gøre noget.</p>
          </ParagraphContainer>
           {(payload.wantsUnemploymentBenefits && payload.giftcard) && (
              <Heighlight>Vi sender en gavekort til {payload.mailAddress}! d. 7 april</Heighlight>
            )}
          {(payload.occupation === "Employee" || payload.occupation === "Unemployed" || payload.occupation === "Student") && (
            <>
            <ParagraphContainer>
              <Heighlight>Vil du følge din indmeldelse</Heighlight>
              <p>Du kan holde øje med din indmeldelse og status via linket - det er nemt.</p>
              {/* <Button href={trackAndTraceUrl}>Følg din indmeldelse</Button> */}
              <CTA className="button" href={trackAndTraceUrl}>Følg din indmeldelse</CTA>
            </ParagraphContainer>
            </>
          )}
        </>
        )}
        {(payload.wantsHRJura || payload.wantsBasic) && (
          <ParagraphContainer>
            <Heighlight>Erhversprodukter</Heighlight>
            <p>Vi ringer dig op inden for to arbejdsdage for at informere mere om produkterne.</p>
          </ParagraphContainer>
        )}
        </Body>
      </ContentWrapper>
      <ContentWrapper>
        <LotteryContainer>
          {/* <LotteryImgContainer>
            <LotteryIcon src="/assets/images/lotteryTicket.svg" alt="Lottery Icon" />
          </LotteryImgContainer> */}
          <LotteryContentContainer>
            <SubHeadline><Gift>&#127873;</Gift>Ase-Lotteriet</SubHeadline>
            <Heighlight>Deltag i det store Ase-lotteri</Heighlight>
            <p>Skrab og vind 100.000 kr. eller en af de 200 gevinster på 1.000 kr.</p>
            <CTA className="underline-link" href="https://mitase.ase.dk/lotteri"> Log ind på MitAse og spil med</CTA>
          </LotteryContentContainer>
        </LotteryContainer>
      </ContentWrapper>
    </Wrapper>
  );
}
